import styled from 'styled-components';

export const Container = styled.div`
  min-height: 0;

  .suggestions-body {
    overflow-y: auto;
  }
  .suggestions-count {
    font-size: 13px;
  }

  .suggestion-card {
    border-color: ${(props) => props.theme.$gray300};
  }

  .suggestion-meta {
    font-size: 13px;
    line-height: 1.6;
  }

  .suggestion-form label {
    color: ${(props) => props.theme.$dark};
    font-weight: 600;
    margin-bottom: 0.35rem;
  }

  .suggestions-footer {
    position: sticky;
    bottom: 0;
    flex-shrink: 0;
    background: ${(props) => props.theme.$white};
  }

  .material-icons {
    font-size: 16px;
  }
`;
